import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import pr1 from '../assets/pr1.jpg';
import pr2 from '../assets/pr2.jpg';
import pr3 from '../assets/pr3.jpg';
import pr4 from '../assets/pr4.jpg';
import pr5 from '../assets/pr5.jpg';
import pr6 from '../assets/pr6.jpg';
import pr7 from '../assets/pr7.jpg';
import pr8 from '../assets/pr8.jpg';
import pr9 from '../assets/pr9.jpg';
import pr10 from '../assets/pr10.jpg';
import pr11 from '../assets/pr11.jpg';
import pr12 from '../assets/pr12.jpg';
import re1 from '../assets/re1.jpeg';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";

// Medical Equipments
import d4 from '../assets/photos/medical_equipments/4.jpg';
import d19 from '../assets/photos/medical_equipments/19.jpg';

// Promotional Materials
import br3 from '../assets/photos/promotional_materials/3.jpg';
import br15 from '../assets/photos/promotional_materials/15.jpg';

// Smart Mobile
import sm2 from '../assets/photos/smart_mobile/2.jpg';
import sm6 from '../assets/photos/smart_mobile/6.jpg';

// Real Estate
import res5 from '../assets/photos/real_estate/5.jpg';
import res18 from '../assets/photos/real_estate/18.jpg';

// Telecom Solutions
import tel1 from '../assets/photos/telecom_solutions/1.jpg';
import tel7 from '../assets/photos/telecom_solutions/7.jpg';

// ICT Solutions
import ict4 from '../assets/photos/ict_solutions/4.jpg';
import ict10 from '../assets/photos/ict_solutions/10.jpg';

// Agricultural Solutions
import ag2 from '../assets/photos/agricultular_solutions/2.jpg';
import ag1 from '../assets/photos/agricultular_solutions/1.jpg';

import edu1 from '../assets/photos/educational_solutions/1.jpg';
import edu10 from '../assets/photos/educational_solutions/10.jpg';
import edu9 from '../assets/photos/educational_solutions/9.jpg';

import hp1 from '../assets/photos/agricultular_solutions/2.jpg';
import hp2 from '../assets/photos/educational_solutions/9.jpg';
import hp3 from '../assets/photos/energy_solutions/9.jpg';
import hp4 from '../assets/photos/ict_solutions/9.jpg';
import hp5 from '../assets/photos/logistics/3.jpg';
import hp6 from '../assets/photos/ict_solutions/15.jpg';
import hp7 from '../assets/photos/promotional_materials/5.jpg';
import hp8 from '../assets/photos/real_estate/5.jpg';
import hp9 from '../assets/photos/smart_mobile/6.jpg';
import hp10 from '../assets/photos/telecom_solutions/3.jpg';


export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-primary"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				
					<div className="row">

						<div className="col-md-12">
							<h1
								style={{
									fontSize: "22px",
									paddingTop: "50px",
									paddingBottom: "50px"
								}}
								className="font-semi-bold text-center"
							>
								WELCOME TO
								<br/>
								<span
									style={{
										fontSize: "48px"
									}}
									className="font-bold"
								>
									JIEZHI TECH
								</span>
							</h1>
						</div>


						<div className="col-md-12">
							<HorizontalImageStrip
								images={[hp1, hp2, hp3, hp4, hp5, hp6, hp7, hp8, hp9, hp10]}
							/>

							<div className="text-center mt-5">
								<button
									className="btn btn-padded btn-rounded btn-light"
									onClick={() => {
										appContext.navTo({
											item: 'contact_us'
										})
									}}
								>
									Contact Us
								</button>
							</div>
						</div>

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
